import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const IMAGES = [
  "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxzb2Z0d2FyZSUyMGRhc2hib2FyZCUyMGludGVyZmFjZXxlbnwwfHx8fDE3ODEyNjM0NzZ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxzb2Z0d2FyZSUyMGRhc2hib2FyZCUyMGludGVyZmFjZXxlbnwwfHx8fDE3ODEyNjM0NzZ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxzb2Z0d2FyZSUyMGRhc2hib2FyZCUyMGludGVyZmFjZXxlbnwwfHx8fDE3ODEyNjM0NzZ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1686061594225-3e92c0cd51b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxzb2Z0d2FyZSUyMGRhc2hib2FyZCUyMGludGVyZmFjZXxlbnwwfHx8fDE3ODEyNjM0NzZ8MA&ixlib=rb-4.1.0&q=85",
];

export const ProjectsSection = ({ t }) => {
  return (
    <div className="font-mono">
      <h2 className="text-2xl sm:text-3xl font-bold text-[var(--text)] mb-2">
        <span className="text-[var(--kw)]">export default</span>{" "}
        <span className="text-[var(--fn)]">Projects</span>
        <span className="text-[var(--muted)]">()</span>
      </h2>
      <p className="text-[11px] text-[var(--cm)] mb-10">{"// "}{t.projects.overline.toLowerCase()}</p>

      <div className="grid md:grid-cols-2 gap-px bg-[var(--border)]">
        {t.projects.items.map((project, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.07 }}
            data-testid={`project-card-${i}`}
            className="bg-[var(--surface)] group overflow-hidden"
          >
            <div className="h-44 md:h-52 overflow-hidden border-b border-[var(--border)]">
              <img
                src={IMAGES[i]}
                alt={project.title}
                loading="lazy"
                className="w-full h-full object-cover opacity-70 group-hover:scale-105 group-hover:opacity-95 transition-[transform,opacity] duration-700"
              />
            </div>
            <div className="p-6">
              <div className="text-[11px] text-[var(--muted)] mb-2">
                <span className="text-[var(--kw)]">&lt;ProjectCard</span>{" "}
                <span className="text-[var(--var)]">id</span>
                <span className="text-[var(--muted)]">=</span>
                <span className="text-[var(--str)]">{"{"}{i}{"}"}</span>
                <span className="text-[var(--kw)]"> /&gt;</span>
              </div>
              <div className="flex items-start justify-between gap-2">
                <h3 className="text-base font-semibold text-[var(--text)] group-hover:text-[#FF5722] transition-colors">
                  {project.title}
                </h3>
                <ArrowUpRight size={16} className="text-[var(--muted)] group-hover:text-[#FF5722] transition-colors shrink-0" />
              </div>
              <p className="mt-2 text-[12px] leading-relaxed text-[var(--muted)]">
                <span className="text-[var(--cm)]">{"// "}</span>
                {project.description}
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                {project.tags.map((tag) => (
                  <span key={tag} className="text-[10px] px-2 py-1 border border-[var(--border)] text-[var(--str)]">
                    "{tag}"
                  </span>
                ))}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
